
  (function() {
    // Map old paths -> new Shopify paths
    var redirects = {
      // Home
      '/': '/',
      '/index.html': '/',

      // Main pages
      '/about-george.html': '/pages/coach-george',
      '/about-george': '/pages/coach-george',

      '/about-averi.html': '/pages/coach-averi',
      '/about-averi': '/pages/coach-averi',

      '/otterhaus-coaches.html': '/pages/coaches',
      '/otterhaus-coaches': '/pages/coaches',

      '/racing.html': '/pages/racing',
      '/racing': '/pages/racing',

      '/otterhaus-athletes.html': '/pages/testimonials',
      '/otterhaus-athletes': '/pages/testimonials',

      '/training-packages.html': '/pages/services',
      '/training-packages': '/pages/services',

      '/coaches-in-training.html': '/pages/coaches',
      '/coaches-in-training': '/pages/coaches',

      '/contact.html': '/pages/contact',
      '/contact': '/pages/contact',

      // Blog root
      '/blog.html': '/blog/',
      '/blog': '/blog/',

      // OLD STORE ITEMS → collections/all
      '/store/c2/Otterhaus_Coaching.html': '/collections/all',
      '/store/c2/Otterhaus_Coaching': '/collections/all',
      '/store/p45/defeet-sock.html': '/collections/all',
      '/store/p45/defeet-sock': '/collections/all',

      // LEGACY BLOG POSTS → blog index
      '/blog/athlete-updates': '/blog/',
      '/blog/event-prep-part-3-event-day': '/blog/',
      '/blog/event-prep-part-2-race-week-taper': '/blog/',
      '/blog/event-prep-part-1-best-bang-for-the-buck': '/blog/',
      '/blog/using-zwift-data-with-wko4': '/blog/',
      '/blog/triathlon-bike-or-road-bike': '/blog/',
      '/blog/not-the-usual-copenhagen-triathlon-story': '/blog/',
      '/blog/do-hard-things': '/blog/',
      '/blog/the-coachs-bookshelf': '/blog/',
      '/blog/ask-a-coach-pmc-chart-basics': '/blog/',
      '/blog/project-bike-scott-plasma-3-tt-tri-bike-build': '/blog/',
      '/blog/2015-military-world-games-recap': '/blog/',
      '/blog/validate-cda-using-best-bike-split': '/blog/',
      '/blog/testimonial-case-study-michael-piermarini': '/blog/',
      '/blog/what-is-normalized-power': '/blog/',
      '/blog/6-tips-for-new-powermeter-users': '/blog/'
    };

    // Normalize current path (strip trailing slash)
    var path = window.location.pathname || '/';
    var normalized = path.replace(/\/+$/, '');
    if (normalized === '') normalized = '/';

    var target = redirects[normalized];

    if (target && normalized !== target) {
      var qs = window.location.search || '';
      var hash = window.location.hash || '';
      window.location.replace(target + qs + hash);
    }
  })();

